import { maskApiLeaderboard } from '../../lib/leaderboardPrivacy';

const sourceBoard = (previous, payload) => {
  if (!payload?.ok || !payload.configured || !Array.isArray(payload.entries)) return previous;
  const entries = maskApiLeaderboard(payload).entries.slice().sort((a, b) => Number(a.rank) - Number(b.rank)).slice(0, 20);
  return {
    ...previous,
    settings: { ...previous.settings, prizePool: payload.prize_pool ?? previous.settings?.prizePool ?? 0 },
    topThree: entries.filter((entry) => Number(entry.rank) <= 3),
    leaderboard: entries.filter((entry) => Number(entry.rank) > 3),
    sourceUpdatedAt: payload.updated_at,
  };
};

export const mergeSheetStandings = (previous, sources) => {
  const stake = sourceBoard({ settings: previous.settings, topThree: previous.topThree, leaderboard: previous.leaderboard }, sources.stake);
  const exclusive = sourceBoard(previous.exclusive || { settings: {}, topThree: [], leaderboard: [] }, sources.exclusive);
  return { ...previous, ...stake, exclusive };
};